import React from 'react';
import {
  Await,
  useLoaderData,
} from '@tanstack/react-router';

import DashboardStats from './Stats';
import DashboardSprks from './Sprks';
import DashboardMemories from './Memories';
import DashboardTimelines from './Timelines';

import type { Stats } from '../../types/stats';

const DashboardHome: React.FC = () => {
  const { stats } = useLoaderData({ strict: false });

  return (
    <>
      <div className="dashboard-header page-header">
        <h2 className="page-title">My <em>dashboard</em></h2>
        <p>Every moment you capture, and every memory you preserve becomes part of your legacy story.</p>
      </div>
      <Await promise={stats}>
        {(stats) => (<DashboardStats stats={stats as Stats} />)}
      </Await>
      <DashboardSprks style="short" />
      <DashboardTimelines style="short" />
      <DashboardMemories style="short" />
    </>
  );
}

export default DashboardHome;
